/**
 * The purpose of guard is to dispaly content base on an arbitrary condition
 *
 */
const Guard = function (props) {
  if (props.condition) return props.children
  return null
}
export default Guard
